import styled from "styled-components";
import { EmailVerificationWrapper } from "../../routes/emailVerification/emailVerification.style";

export const NotFoundWrapper = styled(EmailVerificationWrapper)`
  min-width: 50%;
  min-height: 50vh;
  padding: 4rem 2rem;

  h1 {
    text-align: center;
  }
`;
